<template>
  <div class="maps-wrapper">
    <div id="legend-custom-google-maps" class="custom-legend-maps"></div>
    <div class="google-maps-wrapper" ref="maps"></div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot :google="google" :map="map" />
    </template>
  </div>
</template>

<script>
import GoogleMapsApiLoader from "google-maps-api-loader";

export default {
  props: {
    config: Object,
    zoomValue: Number,
    apiKey: {
      type: String,
      default: "default-gmaps-api-key"
    }
  },

  data() {
    return {
      google: null,
      map: null
    };
  },
  watch: {
    zoomValue: function(value) {
      this.zoomValue = value;
      this.map.setZoom(this.zoomValue);
    }
  },
  async mounted() {
    let apiKey = null;
    const envAPIKey = JSON.stringify(process.env.VUE_GOOGLE_MAPS_API_KEY);
    if (envAPIKey) {
      apiKey = envAPIKey.replace(/"/g, "");
    } else {
      apiKey = this.apiKey;
    }
    const googleMapApi = await GoogleMapsApiLoader({
      libraries: ["places"],
      apiKey
    });

    this.google = googleMapApi;
    this.initMap();
  },

  methods: {
    initMap() {
      const mapContainer = this.$refs.maps;
      this.map = new this.google.maps.Map(mapContainer, this.config);
    }
  }
};
</script>

<style lang="scss" scoped>
.google-maps-wrapper {
  height: 100%;
  width: 100%;
  min-height: 100%;
}

.maps-wrapper {
  @extend .google-maps-wrapper;
  border-radius: 8px;
  overflow: hidden;
}

.custom-legend-maps {
  box-shadow: 1px 1px 12px -1px rgba(#5d5d5d, 0.45);
  // top: 65px;
  // left: 25px;
  border-radius: 4px;
  padding: 0px !important;
}
</style>
